import React from 'react';
import './LegalPage.css';

const PrivacyPage: React.FC = () => {
  return (
    <div className="legal-page">
      <div className="legal-container">
        <div className="legal-header">
          <img src="/rally-font.svg" alt="Rally" className="legal-logo" />
        </div>

        <div className="legal-content">
          <h1>Privacy Policy</h1>
          <p className="last-updated">Last updated: {new Date().toLocaleDateString()}</p>

          <section>
            <h2>1. Information We Collect</h2>
            <h3>Personal Information</h3>
            <ul>
              <li>Name and email address (through Apple Sign-in)</li>
              <li>Apple ID information as provided by Apple</li>
            </ul>
            
            <h3>Location Information</h3>
            <ul>
              <li>Precise location data during race tracking</li>
              <li>GPS coordinates for mile marker proximity detection</li>
            </ul>

            <h3>Voice Content</h3>
            <ul>
              <li>Voice messages recorded through the web interface</li>
              <li>Audio files stored for playback during races</li>
            </ul>

            <h3>Usage Information</h3>
            <ul>
              <li>App usage patterns and preferences</li>
              <li>Device information and operating system</li>
            </ul>
          </section>

          <section>
            <h2>2. How We Use Your Information</h2>
            <p>We use your information to:</p>
            <ul>
              <li>Provide and improve the Rally service</li>
              <li>Enable location-based voice message playback</li>
              <li>Store and deliver voice messages at appropriate times</li>
              <li>Authenticate your account and maintain security</li>
              <li>Communicate with you about your account or the service</li>
            </ul>
          </section>

          <section>
            <h2>3. Information Sharing</h2>
            <p>We do not sell, trade, or rent your personal information to third parties. We may share information in the following circumstances:</p>
            <ul>
              <li>With service providers who help us operate the App (e.g., Firebase, cloud storage)</li>
              <li>When required by law or to protect our legal rights</li>
              <li>With your consent for specific sharing purposes</li>
            </ul>
          </section>

          <section>
            <h2>4. Data Storage and Security</h2>
            <p>
              Your data is stored securely using Firebase services with encryption in transit and at rest. We implement appropriate technical and organizational measures to protect your information against unauthorized access, alteration, disclosure, or destruction.
            </p>
          </section>

          <section>
            <h2>5. Location Data</h2>
            <p>
              Rally requires location access to provide core functionality. We use your location data solely to:
            </p>
            <ul>
              <li>Trigger voice message playback when you reach mile markers</li>
              <li>Track your race progress</li>
              <li>Improve the accuracy of our mile marker system</li>
            </ul>
            <p>
              You can disable location sharing at any time through your device settings, but this will prevent core app functionality from working.
            </p>
          </section>

          <section>
            <h2>6. Voice Messages</h2>
            <p>
              Voice messages are stored securely and are only accessible to the intended runner. Messages are automatically played based on location triggers and are not shared with other users unless explicitly authorized.
            </p>
          </section>

          <section>
            <h2>7. Data Retention</h2>
            <p>
              We retain your information for as long as your account is active or as needed to provide services. You may request deletion of your account and associated data at any time through the app settings.
            </p>
          </section>

          <section>
            <h2>8. Children's Privacy</h2>
            <p>
              Rally is not intended for children under 13 years of age. We do not knowingly collect personal information from children under 13. If we discover that a child under 13 has provided us with personal information, we will delete it immediately.
            </p>
          </section>

          <section>
            <h2>9. Changes to This Privacy Policy</h2>
            <p>
              We may update this Privacy Policy from time to time. We will notify you of any changes by posting the new Privacy Policy on this page and updating the "Last updated" date.
            </p>
          </section>

          <section>
            <h2>10. Your Rights</h2>
            <p>Depending on your location, you may have the right to:</p>
            <ul>
              <li>Access the personal information we hold about you</li>
              <li>Correct inaccurate personal information</li>
              <li>Request deletion of your personal information</li>
              <li>Object to processing of your personal information</li>
              <li>Request data portability</li>
            </ul>
          </section>

          <section>
            <h2>11. Contact Us</h2>
            <p>
              If you have questions about this Privacy Policy or our data practices, please contact us at:
              <br />
              Email: hello@wimlabs.dev
              <br />

            </p>
          </section>
        </div>

        <div className="legal-footer">
          <a href="/">← Back to Rally</a>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPage;